import { sources } from "@/mocks/comic";

const colorMap: Record<string, { icon: string; wrap: string; tag: string }> = {
  primary: {
    icon: "bg-primary-500",
    wrap: "bg-primary-100/70 border-primary-200",
    tag: "bg-primary-100 text-primary-700",
  },
  accent: {
    icon: "bg-accent-500",
    wrap: "bg-accent-100/70 border-accent-200",
    tag: "bg-accent-100 text-accent-700",
  },
  secondary: {
    icon: "bg-secondary-600",
    wrap: "bg-secondary-100/70 border-secondary-200",
    tag: "bg-secondary-100 text-secondary-800",
  },
};

export default function SourceGrid() {
  return (
    <section id="sources" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
            <i className="ri-gallery-line"></i>
            图源推荐
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            四大精品图源栏目
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            按内容类型与画质定位，静漫天堂将静态图源划分为四大栏目，各有侧重，各有所长。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {sources.map((s) => {
            const c = colorMap[s.color] ?? colorMap.primary;
            return (
              <article
                key={s.id}
                className={`relative flex flex-col rounded-2xl border p-5 transition-transform duration-300 hover:-translate-y-1 ${c.wrap}`}
              >
                {s.hot && (
                  <span className="absolute -top-2.5 right-4 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-medium whitespace-nowrap text-background-50">
                    <i className="ri-flashlight-line"></i>
                    热门
                  </span>
                )}
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl text-background-50 ${c.icon}`}
                >
                  <i className="ri-stack-fill"></i>
                </span>
                <h3 className="mt-4 text-lg font-medium text-foreground-950">
                  {s.title}
                </h3>
                <span
                  className={`mt-2 inline-flex w-fit rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap ${c.tag}`}
                >
                  {s.type}
                </span>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {s.desc}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md border border-background-300/60 bg-background-50 px-2 py-0.5 text-xs whitespace-nowrap text-foreground-600"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <a
                  href="#new"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-medium whitespace-nowrap text-primary-600 transition-colors hover:text-primary-700"
                >
                  进入栏目
                  <i className="ri-arrow-right-line"></i>
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}